import React, { useEffect } from 'react';
import Home from '../LandingPage/Home/Home';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import Header from '../Header/Header';
import ServiceDetails from '../LandingPage/ServiceDetails';
import Footer from '../LandingPage/Footer';
import NotFoundPage from '../LandingPage/NotFoundPage';
import About from '../LandingPage/About';
import BlogDetail from '../LandingPage/BlogDetail';
import BlogList from '../LandingPage/Bloglist';
import Support from '../LandingPage/Support';
import ContactUs from '../LandingPage/ContactUs';
import Services from '../LandingPage/Services';
import OurExecutiveTeam from '../LandingPage/OurExecutiveTeam';
import Portfolio from '../LandingPage/Portfolio';

// ScrollToTop component to reset scroll on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const Layout = ({ setShow, setOpen, show }) => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Header setShow={setShow} setOpen={setOpen} show={show} />

      {/* Box with your custom background color */}
     
        <Routes>
          <Route path='/' element={<Home setOpen={setOpen} setShow={setShow} />} />
          <Route path='/service/:slug' element={<ServiceDetails />} />
          <Route path='/about' element={<About />} />
          <Route path='/blog' element={<BlogList />} />
          <Route path='/blog/:slug' element={<BlogDetail />} />
          <Route path='/services' element={<Services />} />
          <Route path='/support' element={<Support />} />
          <Route path='/contact' element={<ContactUs />} />
          <Route path='/pricelist' element={<OurExecutiveTeam />} />
          <Route path='/Portfolio' element={<Portfolio />} />
          {/* 404 fallback */}
          <Route path='*' element={<NotFoundPage />} />
        </Routes>
      

      <Footer />
    </BrowserRouter>
  );
};

export default Layout;
